import { GlobalButton, NavigateLinks } from '@/components';
import { useMemo } from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { AssetsTable, SearchBar } from './components';
import { childrenInventoryPageBreadcrumbs } from '../../config';
import { AssetsFilter } from './models';
import { useAssetsFilter } from './hooks';

import styles from './Assets.module.css';

export const Assets = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => childrenInventoryPageBreadcrumbs(navigate),
    []
  );

  const { filter, initialFilter, setFilter } = useAssetsFilter();
  return (
    <section className={styles.container}>
      <NavigateLinks actualPage='Activos' breadcrumbs={breadcrumbs} />
      <div className={styles.actions}>
        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={() => navigate('create')}
        >
          <AddIcon />
          Agregar activo
        </GlobalButton>
      </div>
      <div className={styles.searchBar}>
        <SearchBar
          filter={filter}
          initialFilter={initialFilter}
          search={(updatedFilter: AssetsFilter) => setFilter(updatedFilter)}
        />
      </div>
      <AssetsTable assetsFilter={filter} />
    </section>
  );
};

export default Assets;
